import React from 'react';
import { PenLine, Save } from 'lucide-react';
import { Input } from '../ui/input';
import { useProgress } from '../../context/ProgressContext';
import { toast } from 'sonner';

export function FillInFields({ moduleId, fields }) {
  const { progress, saveFillInField } = useProgress();
  const moduleFields = progress.fillInFields[moduleId] || {};

  const handleChange = (fieldId, value) => {
    saveFillInField(moduleId, fieldId, value);
  };

  const handleSave = () => {
    toast.success('Your notes have been saved!', {
      description: 'They will be here when you come back.',
      duration: 3000,
    });
  };

  return (
    <div 
      className="bg-white rounded-2xl border-2 border-stone-200 p-6 md:p-8"
      data-testid={`fill-in-fields-${moduleId}`}
    >
      <div className="flex items-start gap-4 mb-6">
        <div className="w-12 h-12 rounded-xl bg-info/10 flex items-center justify-center flex-shrink-0">
          <PenLine className="w-6 h-6 text-info" />
        </div>
        <div>
          <h3 className="font-heading font-bold text-xl text-text mb-1">Your Notes</h3>
          <p className="text-text-muted text-sm">
            Fill in these details for your reference
          </p>
        </div>
      </div>

      <div className="space-y-4">
        {fields.map((field) => (
          <div key={field.id}>
            <label 
              htmlFor={field.id}
              className="block font-medium text-text mb-2"
            >
              {field.label}
            </label>
            <Input
              id={field.id}
              data-testid={`fill-in-${field.id}`}
              type="text"
              value={moduleFields[field.id] || ''}
              onChange={(e) => handleChange(field.id, e.target.value)}
              placeholder={field.placeholder}
              className="h-14 px-4 rounded-xl border-stone-300 focus:border-primary focus:ring-2 focus:ring-primary/20 text-lg bg-stone-50"
            />
          </div>
        ))}
      </div>

      <button
        data-testid="save-notes"
        onClick={handleSave}
        className="mt-6 flex items-center gap-2 text-primary font-medium hover:text-primary-600 transition-colors"
      >
        <Save className="w-4 h-4" />
        <span>Save notes</span>
      </button>
    </div>
  );
}
